import { Text } from '@consta/uikit/Text'
import type { FileHeaderType } from '@core/core/types'
import type { FC } from 'react'

import css from './Setup.css'

export const FileHeaderTable: FC<{ textualHeader?: FileHeaderType }> = ({ textualHeader }) => {
  return (
    <div className={css.codeFrameTextHeader}>
      {textualHeader?.lines.map((line, index) => {
        const lineNumber = index + 1
        return (
          <div key={index} data-testid={`preview-line-${lineNumber}`} className={css.previewLine}>
            <Text size="xs" font="mono" view="ghost" className={css.codeFrameTextHeaderIndex}>
              {lineNumber}
            </Text>
            <Text size="xs" font="mono" view="secondary" className={css.codeFrameTextHeaderText}>
              {line}
            </Text>
          </div>
        )
      })}
    </div>
  )
}
